<template>
  <div :class="['home', context]">
    <!-- Header -->
    <transition name="slide-up">
      <template v-if="!getDetailActive">
        <Header
          v-show="
            (getwidgetViewed || getHomeInLanding) && status !== 'collapsed'
          "
        />
      </template>
    </transition>
    <!-- Viz -->
    <transition name="fade">
      <template
        v-if="getPaint === null && !getwidgetViewed && !getHomeInLanding"
      >
        <WidgetOverlay />
      </template>
    </transition>
    <CanvasViz :key="getCountryId" v-if="getPaint === null" />
    <transition name="slide-down">
      <template
        v-if="
          getPaint === null &&
            (getwidgetViewed || getHomeInLanding) &&
            status !== 'collapsed'
        "
      >
        <Footer />
      </template>
    </transition>
    <!-- Slider -->
    <template v-if="getPaint !== null">
      <PaintingsSliderContainer />
    </template>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import WidgetOverlay from "@/components/WidgetOverlay.vue";
import CanvasViz from "@/components/CanvasViz.vue";
import Footer from "@/components/Footer.vue";
import PaintingsSliderContainer from "@/components/PaintingsSliderContainer.vue";

import { mapGetters } from "vuex";
export default {
  name: "home",
  props: ["context", "status"],
  computed: {
    ...mapGetters([
      "getPaint",
      "getCountryId",
      "getDetailActive",
      "getwidgetViewed",
      "getHomeInLanding"
    ])
  },
  components: {
    Header,
    WidgetOverlay,
    CanvasViz,
    Footer,
    PaintingsSliderContainer
  }
};
</script>

<style lang="scss" scoped>
.home {
  // TODO bg-color
  background: rgb(249, 227, 190);
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  &.landing {
    height: 100%;
  }
  // slide-up
  .slide-up-enter,
  .slide-up-leave-to {
    top: -100px;
  }
  .slide-up-enter-to,
  .slide-up-leave {
    top: 0px;
  }
  .slide-up-enter-active,
  .slide-up-leave-active {
    transition: top 0.7s ease;
  }
  // slide-down
  .slide-down-enter,
  .slide-down-leave-to {
    bottom: -150px;
  }
  .slide-down-enter-to,
  .slide-down-leave {
    bottom: 0px;
  }
  .slide-down-enter-active,
  .slide-down-leave-active {
    transition: bottom 0.7s ease;
  }
  // fade
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-to,
  .fade-leave {
    opacity: 1;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.7s ease;
  }
}
</style>
